import { RedirectMechanismType } from '@graphql/generated';
import { RedirectMechanismProps } from '@apps/guest/routes/HotelBooking/HotelBooking.types';

/**
 * Extracts the primary redirect mechanism (excluding 'partnerSearch') and the interceptor redirect (if any).
 *
 * @param redirectMechanisms - Array of redirect mechanism objects.
 * @returns An object containing the primary redirect and the interceptor redirect, if present.
 */
export function extractHotelRedirects(redirectMechanisms?: RedirectMechanismProps[] | null): {
  hotelPageUrl?: RedirectMechanismProps;
  hotelSearchPageUrl?: RedirectMechanismProps;
} {
  if (!redirectMechanisms) return { hotelPageUrl: undefined, hotelSearchPageUrl: undefined };
  return redirectMechanisms.reduce<{
    hotelPageUrl?: RedirectMechanismProps;
    hotelSearchPageUrl?: RedirectMechanismProps;
  }>((acc, redirect) => {
    if (redirect.type === RedirectMechanismType.partnerSearch) {
      acc.hotelSearchPageUrl ??= redirect;
    } else if (!acc.hotelPageUrl) {
      acc.hotelPageUrl = redirect;
    }
    return acc;
  }, {});
}
